export interface Hit {
  id: number
  objectID: string,
  topic_url: string,
  url: string,
  title: string,
  forum: number,
  forum_title: string,
  content_type: TopicContentType,
  category_id: number,
  category_title: string,
  has_answer: boolean,
  article_label: string
  _highlightResult?: object
}

export interface ZendeskHit {
  objectID: string,
  title: string,
  url: string,
  topic_url?: string,
  content: string,
  _highlightResult: string
}

export interface SalesforceHit {
  objectID: string,
  title: string,
  url: string,
  topic_url?: string,
  content: string,
  _highlightResult: string
}

export function isCommunityResult (el: Hit | ZendeskHit | SalesforceHit): el is Hit {
  return !isZendeskResult(el)
}

export function isZendeskResult (el: Hit | ZendeskHit | SalesforceHit): el is ZendeskHit {
  return el.hasOwnProperty('title') && (el.hasOwnProperty('content') || el.hasOwnProperty('body'))
}

export function isSalesforceResult (el: Hit | ZendeskHit | SalesforceHit): el is SalesforceHit {
  return el.hasOwnProperty('title') && el.hasOwnProperty('content')
}

export type SearchType = 'zendesk' | 'community' | 'salesforce'

export interface DoSearch {
  (input: string): void
}

export interface GetItemPropsFn {
  (data: {item: Hit|ZendeskHit|SalesforceHit, index: number}): {}
}

export interface SearchResults {
  hitsPerPage: number,
  page: number,
  queryID: string,
  nbHits: number,
  hits: Array<Hit|ZendeskHit|SalesforceHit>,
  nbPages: number,
  query: string
}

export type AllSearchResults = {
  [index: string]: SearchResults | undefined
}

export interface TopicClickedEvent {
  type: 'Topic Clicked',
  topic_url: string,
  click_source: string,
  topic_position: number,
  topic_title: string,
  topic_topic_type: string,
  category_id?: number,
  category_title?: string,
}


export interface TopicClickedGoogleAnalyticsEvent {
    eventCategory: 'Live Search',
    eventAction: 'Topic Clicked',
    eventLabel: {
      Link: string,
      Position: number,
      Type: SearchType | TopicContentType
    }
}
